import React from 'react';
import { IonText } from '@ionic/react';
import FarmCard from './FarmCard';

interface IProps {
    farms: any[];
}

const Farms: React.FC<IProps> = (props) => {
    return (
        <>
            {Array.isArray(props.farms) && props.farms.map((farm, index) => <FarmCard farm={farm} key={index} />)}
            {(!Array.isArray(props.farms) || props.farms.length === 0) && (
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '48px 24px', gap: '8px' }}>
                    <IonText color="medium" style={{ fontSize: '14px' }}>No farms found</IonText>
                    <IonText color="medium" style={{ fontSize: '13px' }}>Pull to refresh</IonText>
                </div>
            )}
        </>
    );
};

export default Farms;
